import handlebars from "handlebars";

handlebars.registerHelper("increment", function (value) {
    return parseInt(value) + 1;
});

handlebars.registerHelper("for", function (from, to, incr, block) {
    var accum = "";
    for (var i = from; i < to; i += incr) accum += block.fn(i);
    return accum;
});

handlebars.registerHelper("add", function (a, b) {
    return parseInt(a) + parseInt(b);
});

handlebars.registerHelper("ifCond", function (v1, v2, options) {
    if (v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

handlebars.registerHelper('truncate', function (text, length) {
    if (!text) return '';

    // Strip HTML tags
    let strippedText = text.replace(/<\/?[^>]+(>|$)/g, "");

    // Remove line breaks (both \n and \r)
    strippedText = strippedText.replace(/[\r\n]+/g, ' ');

    // Collapse multiple spaces into one
    strippedText = strippedText.replace(/\s+/g, ' ').trim();

    // Truncate
    if (strippedText.length <= length) {
        return strippedText;
    }

    return strippedText.substring(0, length).trim() + '...';
});

const compile = (htmlTemplate, data) => {
    const template = handlebars.compile(htmlTemplate);
    return template(data);
};

export default compile;
